import {subSleep} from "../AnimationUtilites/sleep";

export default async function typeIn(string,container){
  const splitString = string.split('')
  for(let i=0; i<splitString.length; i++){
    let textNode = document.createTextNode(splitString[i])
    container.appendChild(textNode)
    await subSleep(50)
  }
}